import Database from "../services/database";

const database = new Database();
// 액션 타입 정의

const ADD_OR_UPDATE_CARDS = "cardReducer/ADD_OR_UPDATE_CARDS";
const DELETE_CARDS = "cardReducer/DELETE_CARDS";
const LOAD_CARDS = "cardReducer/LOAD_CARDS";

// 액션 생성 함수

const addOrUpdateCards = (userId, card) => {
  return {
    type: ADD_OR_UPDATE_CARDS,
    card,
    userId,
  };
};

const deleteCards = (userId, card) => {
  return {
    type: DELETE_CARDS,
    card,
    userId,
  };
};

export const loadCards = (cards) => {
  return {
    type: LOAD_CARDS,
    cards,
  };
};

// 초기 값

const initialState = {};

// 리듀서 함수

// database는 비동기 작업일텐데...??

// 맞다 그래서 FIREBASE WARNING: Exception was thrown by user callback.
//  Error: Reducers may not dispatch actions.
// 이거 뜸
// 액션을 디스패치 보내고 state가 리듀서에 맞게 변할때
// 리듀서에 state 만 바꿔주는 작업을 해야될텐데
// 데이터베이스에 업로드하고-> state를 바꾸는 작업을 리듀서 안에 다 넣었음
// 리듀서에 보내기전 할일을 하게 만드는것은 미들웨어
// thunk 를 사용해야 한다.

export const addOrUpdateCardsThunk = (userId, card) => {
  return (dispatch) => {
    // 먼저 할일 한 후
    if (userId) {
      database.updateData(userId, card);
    }
    // 디스패치
    dispatch(addOrUpdateCards(userId, card));
  };
};

export const deleteCardsThunk = (userId, card) => {
  return (dispatch) => {
    // 먼저 할일 한 후
    if (userId) {
      database.deleteData(userId, card);
    }
    // 디스패치
    dispatch(deleteCards(userId, card));
  };
};

// useDatabase hook 에서 사용함
// useEffect 에서 clean up 은 어떻게 해야 될까?
export const loadCardsThunk = (userId) => {
  return (dispatch) => {
    database.loadData(userId, (cards) => {
      dispatch(loadCards(cards));
    });
  };
};

const cardReducer = (prevState = initialState, action) => {
  const newCards = { ...prevState };

  switch (action.type) {
    case ADD_OR_UPDATE_CARDS:
      newCards[action.card.id] = action.card;
      return newCards;

    case DELETE_CARDS:
      delete newCards[action.card.id];
      return newCards;

    case LOAD_CARDS:
      return action.cards;

    default:
      return prevState;
  }
};

export default cardReducer;
